module.exports = __webpack_public_path__ + "static/media/turmeric_getty_mobile.53721aee.jpg";